import React from "react";
import '../../components/bracket/BracketDisplay.css';
import BracketDisplay from "../../components/bracket/BracketDisplay";

import { getViewOnlyBracket } from "../../utilities/js/callouts/CalloutFactory";
// import getURLParam from "../../utilities/js/ParameterRetrieval";
import Toast from '../../components/reusable/Toast';
import { showErrorToast } from "../../utilities/js/ToastHelper";
import LoadingWall from "../../components/reusable/LoadingWall";
import Constants from "../../utilities/js/Constants";
import EditControl from "./EditControl";
import { navigateToErrorPage } from "utilities/js/NavigationHelper";
import BracksetHeader from "components/reusable/BracksetHeader";

class ViewOnlyBracketContainer extends React.Component {
    
    constructor(props){
        super(props);
        
        let bracket = null;
        let doubleElimBracket = null;
        
        this.state = {
            bracket: bracket,
            doubleElimBracket: doubleElimBracket,
            // isDoubleElim: false,
            // tourneyName: "Unknown Tournament",
            toastMessages: [],
            toastPosition: 'top-left',
            // hideByes: false,
            // contestantMap: {},
            isEditable: false,
            editId: null,
            originalLoad: false,
            bracketRecord: null,
            bracketSettings:{
                hideByes: false,
                isDoubleElim: false,
                contestantMap: {},
                tourneyName: "Unknown Tournament",
                roundSpacing: true
            }
        };
        
        this.getDoubleElimDisplay = this.getDoubleElimDisplay.bind(this);
        this.getBracketDisplay = this.getBracketDisplay.bind(this);
    }
    
    componentDidMount(){
        this.getBracket(true);
        
        if(!Constants.MOCK_API){
            setInterval(() => {
                this.getBracket(false);
                console.log('bracket reloaded...');
            }, 6000 * 1000);
        }
    }
    
    
    getBracket(showLoad){

        //only show loading indicator on initial load, not on automatic refreshes
        if(showLoad){
            this.setState({isLoading: true});
        }

        let bracketId = this.props.bracketId;
        getViewOnlyBracket(bracketId).then(result => {
            console.log(result);
            let settings = {
                hideByes: result.hideByes,
                isDoubleElim: result.isDoubleElim,
                tourneyName: result.title,
                contestantMap: result.contestants,
                roundSpacing: result.roundSpacing === undefined ? true : result.roundSpacing
            }
            this.setState({
                bracket: result.bracket,
                doubleElimBracket: result.doubleElimBracket,
                bracketSettings: settings,
                editId: result.bracket_id,
                isEditable: result.editable,
                bracketRecord: result
            })   
            if(!this.state.originalLoad){
                this.setState({originalLoad: true});
            }
        }).catch(error => {
            showErrorToast(this, 'There was an error loading your bracket');
            console.log('There was an error loading your bracket');
            navigateToErrorPage({errorType: Constants.ERROR_TYPE_BRACKET_ERROR});
            //TODO: remove from recently viewed
        }).finally(() => {
            this.setState({isLoading: false});
        });
    }
    
    
    // *********************** UI Helper Methods ***********************
    getDoubleElimDisplay(){
        
        let isDoubleElim = this.state.bracketSettings.isDoubleElim !== undefined ? this.state.bracketSettings.isDoubleElim : false;
        
        let doubleElimDisplay = (<div></div>);
        if(isDoubleElim && this.state.doubleElimBracket){
            doubleElimDisplay = <BracketDisplay header="Double Elimination Bracket" bracket={this.state.doubleElimBracket} contestantMap={this.state.bracketSettings.contestantMap} settings={this.state.bracketSettings} isLocked="true"></BracketDisplay>
        }
        
        return doubleElimDisplay;
    }
    
    getBracketDisplay(){
                
        let bracketDisplay = (<div></div>);
        if(this.state.bracket){
            bracketDisplay = (
            <div className="main-bracket">
                <BracketDisplay header={this.state.bracketSettings.tourneyName} bracket={this.state.bracket} contestantMap={this.state.bracketSettings.contestantMap} format="tournament" settings={this.state.bracketSettings} bracketRecord={this.state.bracketRecord} isLocked="true"></BracketDisplay>
            </div>
            );
        }
        return bracketDisplay;
    }
    
    // *********************** Render UI ***********************
    render(){    
        let bracketDisplay = this.getBracketDisplay();
        let doubleElimDisplay = this.getDoubleElimDisplay();
        
        if(this.state.originalLoad){
            return (
                <>                
                    <EditControl isVisible={this.state.isEditable} editId={this.state.editId}></EditControl>
                    <Toast toastList={this.state.toastMessages} position={this.state.toastPosition} autoDelete="true" autoDeleteTime="5000"/>
                    <LoadingWall isLoading={this.state.isLoading}></LoadingWall>
                    
                    <div className="brackset-container">
                        <BracksetHeader></BracksetHeader>
                        <div className="brackets-display">
                            {bracketDisplay}
                            {doubleElimDisplay}
                        </div>
                        {/* <BracksetFooter></BracksetFooter> */}
                    </div>
                </>
            )
        }else{
            return (<LoadingWall isLoading={this.state.isLoading}></LoadingWall>);
        }
    }
}
    
export default ViewOnlyBracketContainer;
    